// import { createSlice } from "@reduxjs/toolkit";
// import { getPriceForQuantity } from "../utils/discount";
// import CryptoJS from "crypto-js";

// const CART_KEY = "cart";

// const getCartFromStorage = () => {
//   const cart = window.localStorage.getItem(CART_KEY);
//   if (cart) {
//     try {
//       const bytes = CryptoJS.AES.decrypt(cart, "my-new-secret-key");
//       const decryptedCart = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
//       return decryptedCart;
//     } catch (e) {
//       console.error("Error decrypting cart:", e);
//       return { itemsList: [], totalQuantity: 0 };
//     }
//   } else {
//     return { itemsList: [], totalQuantity: 0 };
//   }
// };

// const saveCartToStorage = (cart) => {
//   try {
//     const encryptedCart = CryptoJS.AES.encrypt(
//       JSON.stringify(cart),
//       "my-new-secret-key"
//     ).toString();
//     window.localStorage.setItem(CART_KEY, encryptedCart);
//   } catch (e) {
//     console.error("Error encrypting cart:", e);
//   }
// };

// const initialState = getCartFromStorage();

// const cartSlice = createSlice({
//   name: "cart",
//   initialState,
//   reducers: {
//     addToCart(state, action) {
//       const { product, quantity } = action.payload;
//       if (quantity <= 0) return;

//       const existingItem = state.itemsList.find(
//         (item) => item.product.id === product.id
//       );

//       const basePrice = product.price_info?.quantity_prices?.length
//         ? Math.max(...product.price_info.quantity_prices.map((p) => p.price))
//         : product.price_info?.price || 0;

//       const finalPrice = product.price_info?.quantity_prices
//         ? getPriceForQuantity(product.price_info.quantity_prices, quantity)
//         : product.price_info?.price || 0;

//       const priceTiers = product.price_info?.quantity_prices || [];
//       const priceType = product.price_info?.type || "Unknown";

//       if (existingItem) {
//         existingItem.quantity += quantity;
//       } else {
//         state.itemsList.push({
//           product: {
//             ...product,
//             base_price: basePrice,
//             final_price: finalPrice,
//             price_tiers: priceTiers,
//             price_type: priceType,
//           },
//           quantity,
//         });
//       }

//       state.totalQuantity += quantity;
//       cartSlice.caseReducers.recalculatePrices(state);
//       saveCartToStorage(state);
//     },

//     removeFromCart(state, action) {
//       const id = action.payload;
//       const item = state.itemsList.find((item) => item.product.id === id);
//       if (!item) return;

//       state.itemsList = state.itemsList.filter(
//         (item) => item.product.id !== id
//       );
//       state.totalQuantity -= item.quantity;
//       cartSlice.caseReducers.recalculatePrices(state);
//       saveCartToStorage(state);
//     },

//     updateCart(state, action) {
//       const { product, quantity } = action.payload;
//       const item = state.itemsList.find(
//         (item) => item.product.id === product.id
//       );
//       if (!item) return;

//       item.quantity = quantity;
//       cartSlice.caseReducers.recalculatePrices(state);
//       saveCartToStorage(state);
//     },

//     resetCart(state) {
//       state.itemsList = [];
//       state.totalQuantity = 0;
//       saveCartToStorage(state);
//     },

//     recalculatePrices(state) {
//       state.totalQuantity = state.itemsList.reduce(
//         (acc, item) => acc + item.quantity,
//         0
//       );

//       for (let item of state.itemsList) {
//         if (item.product.price_tiers?.length) {
//           item.product.final_price = getPriceForQuantity(
//             item.product.price_tiers,
//             item.quantity
//           );
//         }
//       }
//     },
//   },
// });

// export const cartActions = cartSlice.actions;
// export default cartSlice.reducer;
import { createSlice } from "@reduxjs/toolkit";
import CryptoJS from "crypto-js";

const CART_KEY = "cart";

const getCartFromStorage = () => {
  const cart = window.localStorage.getItem(CART_KEY);
  if (cart) {
    try {
      const bytes = CryptoJS.AES.decrypt(cart, "my-new-secret-key");
      return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
    } catch (e) {
      console.error("Error decrypting cart:", e);
    }
  }
  return { itemsList: [], totalQuantity: 0 };
};

const saveCartToStorage = (cart) => {
  try {
    const encryptedCart = CryptoJS.AES.encrypt(
      JSON.stringify(cart),
      "my-new-secret-key"
    ).toString();
    window.localStorage.setItem(CART_KEY, encryptedCart);
  } catch (e) {
    console.error("Error encrypting cart:", e);
  }
};

const initialState = getCartFromStorage();

const cartSlice = createSlice({
  name: "cart",
  initialState,
  reducers: {
    addToCart(state, action) {
      const { product, quantity } = action.payload;
      if (quantity <= 0) return;

      const unitPrice = product.price_info?.price || 0;
      const existing = state.itemsList.find(
        (item) => item.product.id === product.id
      );

      if (existing) {
        existing.quantity += quantity;
      } else {
        state.itemsList.push({
          product: {
            ...product,
            unit_price: unitPrice, // cena po komadu
          },
          quantity,
        });
      }

      state.totalQuantity += quantity;
      saveCartToStorage(state);
    },

    removeFromCart(state, action) {
      const id = action.payload;
      const item = state.itemsList.find((i) => i.product.id === id);
      if (!item) return;

      state.totalQuantity -= item.quantity;
      state.itemsList = state.itemsList.filter((i) => i.product.id !== id);
      saveCartToStorage(state);
    },

    updateCart(state, action) {
      const { product, quantity } = action.payload;
      const item = state.itemsList.find((i) => i.product.id === product.id);
      if (!item) return;

      state.totalQuantity += quantity - item.quantity;
      item.quantity = quantity;
      saveCartToStorage(state);
    },

    resetCart(state) {
      state.itemsList = [];
      state.totalQuantity = 0;
      saveCartToStorage(state);
    },
  },
});

export const cartActions = cartSlice.actions;
export default cartSlice.reducer;
